<div class="continer-fluid">
    <section>
        <app-navbar></app-navbar>
        <div class="container">
            <div class="row">
                <div class="col-10">
                    <h2>Share and Invite your friends</h2>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col">
                    <img src="../../../assets/img/referral.svg" alt="referral" class="img-fluid">
                </div>

            </div>

            <div class="row mt-md-5 mt-4">
                <div class="col">
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" placeholder="ASKU54232" aria-label="referral code" aria-describedby="basic-addon2">
                        <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon2">COPY</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-md-5 mt-5">
                <div class="col">
                    <button class="btn">SHARE</button>
                </div>
            </div>
        </div>
    </section>
</div>

<app-bottom-navbar></app-bottom-navbar>